/* Compra por subfamilia · 04-10-2026.
 * Una sección y sus ajustes para todos los productos; precios siempre del CRM.
 * El configurador conserva por producto el arte compatible y recalcula al volver.
 */
(function () {
  'use strict';
  function opciones(config, saved) {
    var result = {};
    (config.options || []).forEach(function (option) {
      var sin = function (v) { return /^(no |sin )/i.test(String(v.label || v.value || '')); };
      var values = (option.values || []).slice().sort(function (a, b) { return (sin(b) ? 1 : 0) - (sin(a) ? 1 : 0); });
      var old = saved && saved[option.code];
      var value = values.find(function (v) { return String(v.value || v.label) === String(old); }) ||
        values.find(function (v) { return v.isDefault; }) || values[0];
      if (value) result[option.code] = String(value.value || value.label);
    });
    if (config.sidesCode) {
      var forced = config.sidesForced;
      var model = config.sizeCode && result[config.sizeCode];
      if (forced == null && model && Number((config.modelSides || {})[model]) === 1) forced = 1;
      if (forced == null && model && Number((config.modelSidesMin || {})[model]) === 2) forced = 2;
      if (forced != null) result[config.sidesCode] = String(forced);
    }
    return result;
  }
  function cantidadValida(config, value) {
    var n = Number(value);
    return Number.isInteger(n) && n > 0 && (!config.minQty || n >= Number(config.minQty)) && (!config.maxQty || n <= Number(config.maxQty));
  }
  // Solo para las pruebas de las reglas, sin DOM ni red.
  if (typeof module === 'object' && module.exports) { module.exports = { opciones: opciones, cantidadValida: cantidadValida }; return; }
  if (window.__papiroCambio) return;
  window.__papiroCambio = true;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  var requests = new Map(), configs = new Map(), cards = new Map();
  var running = false, pendingHistory = null, revision = 0, quoteTimer, initialURL = new URL(location.href);
  var group = document.querySelector('[data-pf-compra]');
  if (!group) return;
  var proposed = group.querySelector('template[data-pf-propuesto]');
  var notice = group.querySelector('.papiro-cambio-aviso');
  // En el editor no se sustituye una sección con HTML guardado: perdería los
  // ajustes pendientes de la vista previa. Abrir el producto real usa la misma
  // ficha compartida y deja a Shopify conservar y renderizar esos ajustes.
  if (designMode) {
    var requestedPreview = initialURL.searchParams.get('producto');
    var previewLinks = Array.from(group.querySelectorAll('a.pf-card[data-pf-handle][data-pf-url]'));
    if (proposed) previewLinks = previewLinks.concat(Array.from(proposed.content.querySelectorAll('a.pf-card[data-pf-handle][data-pf-url]')));
    var previewCard = previewLinks.find(function (a) { return a.dataset.pfHandle === requestedPreview; });
    if (previewCard) {
      var previewURL = new URL(previewCard.dataset.pfUrl, location.origin);
      if (previewURL.origin === location.origin && /\/products\/[^/]+$/.test(previewURL.pathname)) {
        // Compatibilidad con enlaces del editor que ya estaban abiertos.
        var previewQuantity = initialURL.searchParams.get('cantidad');
        if (/^[1-9][0-9]*$/.test(previewQuantity || '')) previewURL.searchParams.set('cantidad', previewQuantity);
        location.replace(previewURL.href);
        return;
      }
    }
  }
  var activeSection = document.querySelector('[data-papiro-producto]');
  activeSection = activeSection && activeSection.closest('.shopify-section');
  if (!activeSection) return;
  var sectionId = activeSection.id.replace(/^shopify-section-/, '');
  var current = activeSection.querySelector('[data-papiro-producto]').getAttribute('data-papiro-producto');
  var original = current;
  function bid(section) { var root = section.querySelector('[id^="papiro-cfg-"]'); return root && root.id.replace('papiro-cfg-', ''); }
  function cantidad() { var q = activeSection.querySelector('.pcfg-qty-input'); return q ? Number(q.value) : 0; }
  function message(text, error) { if (notice) { notice.textContent = text; notice.hidden = !text; notice.setAttribute('role', error ? 'alert' : 'status'); } }
  function rememberCards() {
    group.querySelectorAll('a.pf-card[data-pf-handle]').forEach(function (a) { cards.set(a.dataset.pfHandle, a.closest('li')); });
    if (proposed) { var li = proposed.content.querySelector('li'); if (li) cards.set(original, document.importNode(li, true)); }
  }
  rememberCards();
  function card(handle) { var li = cards.get(handle); return li && li.querySelector('a.pf-card'); }
  function validProductURL(a) {
    var u = new URL(a.getAttribute('data-pf-url'), location.origin);
    if (u.origin !== location.origin || !/\/products\/[^/]+$/.test(u.pathname)) throw new Error('Producto inválido');
    u.searchParams.set('section_id', sectionId);
    return u;
  }
  function pide(a) {
    var url = validProductURL(a).href;
    if (requests.has(url)) return requests.get(url);
    var p = fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(20000) }).then(function (r) {
      if (!r.ok) throw new Error('Sección no disponible');
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var meta = doc.querySelector('[data-papiro-producto]');
      var section = meta && meta.closest('.shopify-section');
      if (!section || meta.dataset.papiroProducto !== a.dataset.pfHandle || !section.querySelector('[id^="papiro-cfg-"]')) throw new Error('Respuesta incompleta');
      return section.outerHTML;
    });
    requests.set(url, p);
    p.catch(function () { requests.delete(url); });
    return p;
  }
  function ejecuta(root) {
    root.querySelectorAll('script').forEach(function (old) {
      var type = (old.getAttribute('type') || '').toLowerCase();
      if (type && !['text/javascript', 'application/javascript', 'module'].includes(type)) return;
      if (old.src && Array.from(document.scripts).some(function (s) { return !root.contains(s) && s.src === old.src; })) return;
      var next = document.createElement('script');
      Array.from(old.attributes).forEach(function (attr) { next.setAttribute(attr.name, attr.value); });
      if (!old.src) next.textContent = old.textContent;
      old.replaceWith(next);
    });
  }
  function esperaConfigurador(section) {
    var id = bid(section), root = section.querySelector('[id^="pcfg-debug-"][data-template]'), productId = root && root.dataset.template;
    var cancel;
    var promise = new Promise(function (resolve, reject) {
      var timeout;
      function clean() { clearTimeout(timeout); document.removeEventListener('pcfg:ready', ready); document.removeEventListener('pcfg:error', failed); }
      function belongs(e) { return e.detail && e.detail.bid === id && String(e.detail.productId) === String(productId); }
      function ready(e) { if (belongs(e)) { clean(); resolve(e.detail); } }
      function failed(e) { if (belongs(e)) { clean(); reject(new Error('No se pudo cargar la configuración')); } }
      cancel = clean;
      document.addEventListener('pcfg:ready', ready); document.addEventListener('pcfg:error', failed);
      timeout = setTimeout(function () { clean(); reject(new Error('Tiempo de carga agotado')); }, 20000);
    });
    promise.catch(function () {});
    return { promise: promise, cancel: function () { cancel(); } };
  }
  function updateURL(handle, replace) {
    if (designMode) return;
    var u = new URL(initialURL.href);
    u.searchParams.delete('section_id');
    if (handle === original) u.searchParams.delete('producto'); else u.searchParams.set('producto', handle);
    var n = cantidad(); if (n > 0) u.searchParams.set('cantidad', String(n));
    history[replace ? 'replaceState' : 'pushState'](history.state, '', u.href);
  }
  function exchange(next, previous) {
    var oldCard = cards.get(previous), chosen = cards.get(next);
    if (chosen && chosen.isConnected && oldCard) chosen.replaceWith(oldCard);
    else if (chosen && chosen.isConnected) chosen.remove();
  }
  async function cambia(handle, opts) {
    opts = opts || {};
    var a = card(handle);
    if (!a || handle === current || running) return;
    running = true; revision++;
    var previous = current, quantity = opts.quantity || cantidad(), oldSection = activeSection, waiting, rollbackHTML;
    oldSection.classList.add('papiro-cambiando'); oldSection.setAttribute('aria-busy', 'true'); message('');
    try {
      var results = await Promise.all([pide(a), pide(card(previous))]);
      var html = results[0]; rollbackHTML = results[1];
      var box = document.createElement('div'); box.innerHTML = html;
      var next = box.firstElementChild;
      if (!window.PapiroCompra) throw new Error('El configurador aún está cargando');
      var snapshot = window.PapiroCompra.capture(bid(oldSection));
      window.PapiroCompra.dispose(bid(oldSection));
      oldSection.replaceWith(next); activeSection = next; current = handle;
      next.setAttribute('aria-busy', 'true');
      waiting = esperaConfigurador(next);
      ejecuta(next);
      window.PapiroCompra.setQuantity(bid(next), quantity);
      await waiting.promise;
      next.removeAttribute('aria-busy');
      exchange(handle, previous);
      if (!opts.history) updateURL(handle, !!opts.replace);
      if (snapshot && ((snapshot.files || []).length || (snapshot.variants || []).length || (snapshot.multi && snapshot.multi.slots || []).some(function (s) { return s.url; }))) {
        message('Tu trabajo anterior queda guardado en su producto. Cada formato conserva su propio diseño.');
      }
      if (!opts.noScroll) {
        var y = next.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: Math.max(0, y), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        var h = next.querySelector('h1'); if (h) { h.tabIndex = -1; h.focus({ preventScroll: true }); }
      }
      cotiza();
    } catch (error) {
      if (waiting) waiting.cancel();
      if (activeSection !== oldSection) {
        window.PapiroCompra.dispose(bid(activeSection));
        var rollback = document.createElement('div'); rollback.innerHTML = rollbackHTML;
        var restored = rollback.firstElementChild;
        activeSection.replaceWith(restored); activeSection = restored; current = previous;
        ejecuta(restored);
        window.PapiroCompra.setQuantity(bid(restored), quantity);
      }
      if (opts.history) updateURL(previous, true);
      message('No hemos podido cargar esa opción. Tu selección sigue aquí; vuelve a pulsar la tarjeta para intentarlo.', true);
    } finally {
      if (waiting) waiting.cancel();
      oldSection.classList.remove('papiro-cambiando'); oldSection.removeAttribute('aria-busy'); running = false;
      if (pendingHistory) { var pending = pendingHistory; pendingHistory = null; navegaHistorial(pending); }
    }
  }
  function config(id) {
    if (configs.has(id)) return configs.get(id);
    var p = fetch('https://app.papiro.es/api/product-config?productId=' + encodeURIComponent(id), { signal: AbortSignal.timeout(15000) }).then(function (r) {
      if (!r.ok) throw new Error('Configuración no disponible'); return r.json();
    }).then(function (c) { if (!c.productId || !Array.isArray(c.options)) throw new Error('Configuración incompleta'); return c; });
    configs.set(id, p); p.catch(function () { configs.delete(id); }); return p;
  }
  function precio(a, text, detail, busy) {
    var p = a.querySelector('[data-pf-cotizacion]'); if (!p) return;
    p.querySelector('.pf-precio__ya').textContent = text;
    p.querySelector('.pf-precio__detalle').textContent = detail || '';
    p.setAttribute('aria-busy', busy ? 'true' : 'false');
  }
  async function cotizaUna(a, quantity, version) {
    var id = a.dataset.template;
    if (!id) return;
    try {
      var c = await config(id);
      if (version !== revision) return;
      var saved = window.PapiroCompra && window.PapiroCompra.saved && window.PapiroCompra.saved(id);
      var reparto = !!(saved && saved.hasMultiDesign);
      if (reparto) quantity = Number(saved.quantity);
      if (!cantidadValida(c, quantity)) {
        precio(a, quantity < Number(c.minQty) ? 'Desde ' + c.minQty + ' uds' : 'Hasta ' + c.maxQty + ' uds', 'Elige una cantidad disponible', false); return;
      }
      var dimensions = saved && saved.measures;
      if (c.measures && !dimensions) { precio(a, 'Precio según medida', 'Elige esta opción para indicar el tamaño', false); return; }
      var payload = Object.assign({ productId: id, quantity: quantity, options: opciones(c, saved && saved.options), shop: group.dataset.pfShop }, dimensions || {});
      var extra = window.pcfgExtraOfertas && window.pcfgExtraOfertas(bid(activeSection));
      if (extra) payload.extra = Object.assign({}, payload.extra || {}, extra);
      var r = await fetch('https://app.papiro.es/api/pricing', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: AbortSignal.timeout(15000) });
      if (!r.ok) throw new Error('No se pudo calcular');
      var result = await r.json(), amount = Number(result.price);
      if (result.price == null || !Number.isFinite(amount) || amount <= 0 || result.error || result.success === false) throw new Error('Precio no disponible');
      if (version === revision) precio(a, new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(amount), quantity + ' uds' + (reparto ? ' de tu reparto guardado' : '') + ' · IVA incluido · entrega estándar', false);
    } catch (error) { if (version === revision) precio(a, 'Ver precio', 'Elige esta opción para calcularlo', false); }
  }
  function cotiza() {
    clearTimeout(quoteTimer);
    var version = ++revision, n = cantidad();
    var rows = Array.from(group.querySelectorAll('a.pf-card[data-pf-handle]'));
    rows.forEach(function (a) { precio(a, 'Calculando precio…', n > 0 ? n + ' uds' : '', true); });
    quoteTimer = setTimeout(async function () {
      // Dos consultas a la vez como máximo, también en subfamilias grandes.
      for (var i = 0; i < rows.length && version === revision; i += 2) await Promise.all(rows.slice(i, i + 2).map(function (a) { return cotizaUna(a, n, version); }));
    }, 250);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.pf-card[data-pf-handle]');
    if (designMode || !a || !group.contains(a) || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault(); cambia(a.dataset.pfHandle);
  });
  document.addEventListener('pointerover', function (e) {
    var a = e.target.closest && e.target.closest('a.pf-card[data-pf-handle]');
    if (!designMode && a && group.contains(a)) pide(a).catch(function () {});
  }, { passive: true });
  document.addEventListener('input', function (e) { if (activeSection.contains(e.target) && e.target.matches('.pcfg-qty-input')) cotiza(); });
  document.addEventListener('pcfg:quote', function (e) { if (e.detail && e.detail.bid === bid(activeSection)) { cotiza(); if (!running) updateURL(current, true); } });
  function navegaHistorial(u) {
    if (running) { pendingHistory = u; return; }
    var handle = u.searchParams.get('producto') || original, quantity = Number(u.searchParams.get('cantidad'));
    if (!cards.has(handle)) return;
    if (handle === current) { if (quantity > 0 && window.PapiroCompra) window.PapiroCompra.setQuantity(bid(activeSection), quantity); }
    else cambia(handle, { history: true, quantity: quantity });
  }
  window.addEventListener('popstate', function () { if (!designMode) navegaHistorial(new URL(location.href)); });
  var style = document.createElement('style');
  style.textContent = '.papiro-cambiando{opacity:.45;pointer-events:none}.pf-precio__detalle{display:block;font-size:12px;line-height:1.5;margin-top:5px;font-weight:400}.papiro-cambio-aviso{font-size:14px;line-height:1.5;margin:0 0 20px}.papiro-cambio-aviso[hidden]{display:none}';
  document.head.append(style);
  var requested = initialURL.searchParams.get('producto');
  if (!designMode && requested && cards.has(requested) && requested !== current) cambia(requested, { replace: true, noScroll: true, quantity: Number(initialURL.searchParams.get('cantidad')) });
  else {
    var initialQuantity = Number(initialURL.searchParams.get('cantidad'));
    if (initialQuantity > 0 && window.PapiroCompra) window.PapiroCompra.setQuantity(bid(activeSection), initialQuantity);
    cotiza();
  }
})();
